import Rest from '../rest'

export default class Funnels extends Rest {
    constructor() {
        super('/funnels')
    }
    getAllFunnels(){
        return this.getAllV2('');
    }
    getFunnel(id) {
        let params = {
            'with':'stages.status.action;stages.action;stages.idles'
        }
        if(!id || id == null) {
            id = '';
            params = { 
                'where':'main:1',
                'with':'stages.status.action;stages.action;stages.idles',
            }
        }
        return this.getV2('',id,params);     
    }
}
